import { useEffect, useRef } from "react";

export default function HeroSection() {
  const titleRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = titleRef.current;
    if (!el) return;
    el.style.opacity = "0";
    el.style.transform = "translateY(30px)";
    setTimeout(() => {
      el.style.transition = "opacity 0.9s ease, transform 0.9s ease";
      el.style.opacity = "1";
      el.style.transform = "translateY(0)";
    }, 100);
  }, []);

  return (
    <section
      id="home"
      className="relative w-full min-h-screen flex items-center overflow-hidden"
    >
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/9d6a5471d0f260d443792aee89a1140b.jpg"
          alt="Hero background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-black/70 via-black/50 to-black/60" />
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 md:px-16 py-32 flex flex-col lg:flex-row items-center gap-16">
        {/* Left: Headline */}
        <div ref={titleRef} className="flex-1 w-full">
          <p className="text-xs font-semibold tracking-[0.25em] text-white/50 uppercase mb-6">
            iOS Application Development
          </p>
          <h1 className="text-5xl md:text-7xl font-extrabold text-white leading-tight mb-6">
            Modern iOS<br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-emerald-400 to-teal-300">
              Applications
            </span><br />
            For Everyone
          </h1>
          <p className="text-white/70 text-base md:text-lg max-w-md leading-relaxed">
            BAZA DOO BECEJ is a team of experts crafting premium iOS experiences — from powerful VPN protection to intelligent device optimization tools.
          </p>
        </div>

        {/* Right: Stats */}
        <div className="flex-1 w-full flex flex-col gap-6 lg:items-end">
          {[
            { value: "99.9%", label: "Uptime & Reliability" },
          ].map((stat) => (
            <div
              key={stat.label}
              className="bg-white/10 backdrop-blur-sm border border-white/10 rounded-2xl px-8 py-5 w-full lg:max-w-xs"
            >
              <p className="text-3xl font-bold text-white">{stat.value}</p>
              <p className="text-white/60 text-sm mt-1">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
        <span className="text-white/40 text-xs tracking-widest uppercase">Scroll</span>
        <i className="ri-arrow-down-line text-white/40 text-lg" />
      </div>
    </section>
  );
}
